import React, { Fragment } from "react";
import { Card, Col, Button } from 'react-bootstrap';
import '../../../../../styles/lrf.scss'

const Lrf = (props) => {

    const deletar = async (id) => {
        props.deletar(id)
        await props.fetchLrfIn()
    }

    const editar = async (id) => {
        props.editar(id)
    }

    const setLrf = (bimestre) => {
        switch (bimestre) {
            case "1bim":
                return "1º Bimestre"
                break;
            case "2bim":
                return "2º Bimestre"
                break;
            case "3bim":
                return "3º Bimestre"
                break;
            case "4bim":
                return "4º Bimestre"
                break;
            case "5bim":
                return "5º Bimestre"
                break;
            case "6bim":
                return "6º Bimestre"
                break;
            case "1sem":
                return "1º Semestre"
                break;
            case "2sem":
                return "2º Semestre"
                break;
            case "1qua":
                return "1º Quadrimestre"
                break;
            case "2qua":
                return "2º Quadrimestre"
                break;
            case "3qua":
                return "3º Quadrimestre"
                break;
            case "ano":
                return "Anual"
                break;
        }
    }

    return (
        <Fragment>
            <Col>
                <Card className='card-list'>
                    <Card.Body>
                        <Card.Title className="cabeca-card" key={props.key}>{setLrf(props.lrf.bimestre)}/{props.lrf.ano}</Card.Title>
                    </Card.Body>
                    <hr />
                    <Button type="button" className="botao-leis" onClick={() => editar(props.lrf._id)} variant='primary'>Editar</Button>
                    <Button type='button' className="botao-leis" onClick={() => deletar(props.lrf._id)} variant='danger'>Excluir</Button>
                </Card>
            </Col>
        </Fragment >)
}

export default Lrf;